<header class="jobguru-header-area stick-top forsticky page-header">
  <div class="menu-animation">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2">
          <div class="site-logo">
            <a href="index.html">
              <img src="./assets/dist/img/logo/logo.png" alt="telOne logo" />
              <!--<img src="./assets/dist/img/logo/telonelogo.png" alt="telOne logo" class="non-stick-logo"/>
              <img src="./assets/dist/img/logo/logo.png" alt="telOne logo" class="stick-logo"/>-->
            </a>
          </div>
          <!-- Responsive Menu Start -->
          <div class="jobguru-responsive-menu"></div>
          <!-- Responsive Menu Start -->
        </div>
        <div class="col-lg-6">
          <div class="header-menu">
            <nav id="navigation">
              <ul id="jobguru_navigation">
                <li><a href="#" routerLink="" (click)="goToHome()">Home</a></li>
                <li [routerLinkActive]="['active']"><a routerLink="/dashboard/profile">My Profile</a></li>
                <!-- <li *ngIf="!loggedInClient"><a href="#" routerLink="/register"><i class="fa fa-user"></i>sign up</a></li>
                <li *ngIf="!loggedInClient"><a href="#" routerLink="/login"><i class="fa fa-lock"></i>login</a></li>
                <li *ngIf="loggedInClient" class="jp"><a href="#" (click)="logout()"><i class="fa fa-power-off"></i>logout</a></li> -->
<!--                <li><a href="vacancies.html">Vacancy List</a></li>-->
              </ul>
            </nav>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="header-right-menu">
            <ul>
              <li *ngIf="!loggedInClient"><a href="#" routerLink="/register"><i class="fa fa-user"></i>sign up</a></li>
              <li *ngIf="!loggedInClient"><a href="#" routerLink="/login"><i class="fa fa-lock"></i>login</a></li>
              <li *ngIf="loggedInClient"><a href="#" (click)="logout()"><i class="fa fa-power-off"></i>logout</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
